<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
  },
  created() {
    this.tips = [
      {
        body: [
          `The Schedule component enables authorized users to configure System Notifications, ${this.properties['SYSTEM_LABEL-NEARMATCH']} Notifications, and ${this.properties['SYSTEM_LABEL-NEARMATCH']} Data Processing jobs`,
        ],
      },
      {
        header: 'System Notifications',
        body: [
          'The purpose of the System Notification feature is to alert system administrators or support personnel of errors or failures within the application. The notifications are sent immediately when the failure occurs.',
        ],
      },
      {
        header: `${this.properties['SYSTEM_LABEL-NEARMATCH']} Notifications`,
        body: [
          `The purpose of the ${this.properties['SYSTEM_LABEL-NEARMATCH']} Notification feature is to notify contact person(s) and users of pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es). This notification can be sent to the State, Districts or Schools. All notifications can be sent on a daily, weekly, or monthly basis. The State notification can be sent to any valid email address. The District notification can be sent to the specified Contact Person for the location or all users within the Location Administrator role. The School notification can be sent to the specified Contact Person for the location or all users within the Building Administrator role. The notification is only sent when there is at least one outstanding pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}`,
        ],
      },
      {
        header: `${this.properties['SYSTEM_LABEL-NEARMATCH']} Data Processing`,
        body: [
          `The purpose of the ${this.properties['SYSTEM_LABEL-NEARMATCH']} Data Processing feature is to enable automatic cancelation of pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es) older the a specified age. This feature can be configured to run daily, weekly, monthly, or yearly. When the job runs, the system will cancel any pending ${this.properties['SYSTEM_LABEL-NEARMATCH']}(s/es) that are older than the specified age.`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
